import { get } from '../client/axiosClient';
import { userCacheEndpoints } from '../endpoints/userCache.endpoints';
import type { ApiResponse, UserCache } from '../types';

class UserCacheService {
  async getAll(): Promise<ApiResponse<UserCache[]>> {
    const response = await get<any>(userCacheEndpoints.list());
    const raw = response.data;
    return { success: raw?.success ?? false, message: raw?.message, data: raw?.data ?? [] };
  }
}

export const userCacheService = new UserCacheService();
export default userCacheService;
